import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Menu, X } from 'lucide-react';
import Logo from './Logo';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header
      className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'shadow-lg bg-dark-900' : 'bg-transparent'
        }`}
    >
      <div className="container flex justify-between items-center px-4 py-4 mx-auto">
        <Link to="/" className="flex items-center space-x-2 text-white">
          <Logo className="w-10 h-10" />
          <span className="text-xl font-bold">WinMax Optimizer</span>
        </Link>

        <nav className="hidden items-center space-x-8 md:flex">
          <Link to="/" className="text-white transition-colors hover:text-primary-400">Home</Link>
          <Link to="/product/winmax-custom-duration" className="text-white transition-colors hover:text-primary-400">Products</Link>
          <Link to="/download" className="text-white transition-colors hover:text-primary-400">Download</Link>
          <Link to="https://licensing.winmaxoptimizer.com" className="text-white transition-colors hover:text-primary-400">My License</Link>
          <Link to="https://affiliates.winmaxoptimizer.com" className="text-white transition-colors hover:text-primary-400">Affiliates</Link>
          <Link to="/product/winmax-custom-duration" className="flex items-center px-4 py-2 text-white rounded-md transition-colors bg-primary-600 hover:bg-primary-700">
            <ShoppingCart size={16} className="mr-2" />
            <span>Buy Now</span>
          </Link>
        </nav>

        <button
          className="text-white md:hidden focus:outline-none"
          onClick={toggleMobileMenu}
        >
          {isMobileMenuOpen ? (
            <X size={24} />
          ) : (
            <Menu size={24} />
          )}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="absolute w-full shadow-lg md:hidden bg-dark-900">
          <div className="flex flex-col px-4 py-4 space-y-4">
            <Link to="/" className="text-white transition-colors hover:text-primary-400" onClick={toggleMobileMenu}>Home</Link>
            <Link to="/product/winmax-custom-duration" className="text-white transition-colors hover:text-primary-400" onClick={toggleMobileMenu}>Products</Link>
            <Link to="/download" className="text-white transition-colors hover:text-primary-400" onClick={toggleMobileMenu}>Download</Link>
            <Link to="https://licensing.winmaxoptimizer.com" className="text-white transition-colors hover:text-primary-400" onClick={toggleMobileMenu}>My License</Link>
            <Link to="https://affiliates.winmaxoptimizer.com" className="text-white transition-colors hover:text-primary-400" onClick={toggleMobileMenu}>Affiliates</Link>
            <Link
              to="/product/winmax-custom-duration"
              className="px-4 py-2 text-center text-white rounded-md transition-colors bg-primary-600 hover:bg-primary-700"
              onClick={toggleMobileMenu}
            >
              Buy Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;